
<form #mapForm="ngForm" autocomplete="off">

  <mat-form-field class="fullWidth" >
    <mat-label>Name</mat-label>
    <input matInput required [(ngModel)]="data.serverName"  name="name" required>
    <mat-error>
      Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>


  <mat-form-field class="fullWidth">
    <mat-label>Address</mat-label>
    <input matInput [(ngModel)]="data.address" name="address" required>
    <mat-error>
      Address is <strong>required</strong>
    </mat-error>
  </mat-form-field>



</form>
